import base from '../dr-base'
import drBaseActions from '../dr-base-actions'
import drGrid from './dr-grid.vue'

const schema = {
  ...base,
  $Type: 'dr-grid',
  group: 'Advanced',
  icon: 'th',
  name: 'Grid',
  properties: {
    ...base.properties,
    Rows: {
      name: 'vuetifyWidgets.dr-grid.rows',
      type: 'string'
    },
    Columns: {
      name: 'vuetifyWidgets.dr-grid.columns',
      type: 'array',
      component: 'dr-grid-columns-editor'
    },
    Buttons: {
      name: 'vuetifyWidgets.dr-grid.buttons',
      type: 'array',
      component: 'dr-grid-buttons-editor'
    },
    Width: {
      name: 'vuetifyWidgets.dr-grid.width',
      validationRules: [{ regexTemplate: /.*[0-9]$/, errorMessage: 'vuetifyWidgets.dr-grid.unitNotSet' }],
      HintText: 'vuetifyWidgets.dr-grid.availableUnits',
      type: 'string'
    },
    Height: {
      name: 'vuetifyWidgets.dr-grid.height',
      validationRules: [{ regexTemplate: /.*[0-9]$/, errorMessage: 'vuetifyWidgets.dr-grid.unitNotSet' }],
      HintText: 'vuetifyWidgets.dr-grid.availableUnits',
      type: 'string'
    },
    TreeData: {
      name: 'vuetifyWidgets.dr-grid.treeData',
      type: 'boolean'
    },
    GroupColumnName: {
      name: 'vuetifyWidgets.dr-grid.groupColumnName',
      type: 'string'
    },
    GroupTitleFieldName: {
      name: 'vuetifyWidgets.dr-grid.groupTitleFieldName',
      type: 'string'
    },
    PathFieldName: {
      name: 'vuetifyWidgets.dr-grid.pathFieldName',
      type: 'string'
    },
    GroupCellStyle: {
      name: 'vuetifyWidgets.dr-grid.groupCellStyle',
      type: 'string'
    },
    GroupColumnFilter: {
      name: 'vuetifyWidgets.dr-grid.groupColumnFilter',
      type: 'string'
    },
    OnClickAction: {
      name: 'vuetifyWidgets.dr-button.onClickAction',
      type: 'object',
      component: 'dr-prop-action',
      properties: { 
        ...drBaseActions.properties.OnClickAction.properties
      }
    },
    GroupColumnWidth: {
      name: 'vuetifyWidgets.dr-grid.groupColumnWidth',
      type: 'number'
    },
    GroupColumnMinWidth: {
      name: 'vuetifyWidgets.dr-grid.groupColumnMinWidth',
      type: 'number'
    },
    GroupColumnResizable: {
      name: 'vuetifyWidgets.dr-grid.groupColumnResizable',
      type: 'boolean'
    },
    GroupColumnSortable: {
      name: 'vuetifyWidgets.dr-grid.groupColumnSortable',
      type: 'boolean'
    },
    GroupColumnFloatingFilter: {
      name: 'vuetifyWidgets.dr-grid.groupColumnFloatingFilter',
      type: 'boolean'
    },
    MasterDetail: {
      name: 'Master-detail',
      type: 'boolean'
    },
    ChildColumns: {
      name: 'vuetifyWidgets.dr-grid.childColumns',
      type: 'string',
      component: 'dr-grid-columns-editor'
    },
    ChildDataFieldName: {
      name: 'vuetifyWidgets.dr-grid.childDataFieldName',
      type: 'string'
    }
  }
}

export default {
  schema,
  component: drGrid,
  propEditors: [
    {
      name: 'dr-grid-columns-editor'
    },
    {
      name: 'dr-grid-buttons-editor'
    },
    {
      name: 'dr-prop-action'
    }
  ]
}
